import Slider, { Settings } from 'react-slick';
import './slick.css';
import { forwardRef } from 'react';

interface ICustomSliderProps extends Settings {
  children: React.ReactNode;
  nextArrow?: JSX.Element;
  prevArrow?: JSX.Element;
}

export const CustomSlider = forwardRef<Slider, ICustomSliderProps>(({ children, ...rest }, ref) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const SlickArrowLeft = ({ currentSlide = 0, slideCount = 0, ...props }) => (
    <div
      {...props}
      className={'slick-prev slick-arrow' + (currentSlide === 0 && !rest.infinite ? ' slick-disabled' : '')}
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    ></div>
  );

  const SlickArrowRight = ({ currentSlide = 0, slideCount = 0, ...props }) => {
    return (
      <div
        {...props}
        className={
          'slick-next slick-arrow' +
          (currentSlide === slideCount - (rest.slidesToShow ?? 3) && !rest.infinite ? ' slick-disabled' : '')
        }
        aria-hidden="true"
        aria-disabled={currentSlide === slideCount - 1 ? true : false}
      />
    );
  };

  const settings = {
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
  };

  return (
    <Slider {...rest} {...settings} ref={ref}>
      {children}
    </Slider>
  );
});

CustomSlider.displayName = 'CustomSlider';
